import React from "react";
import { CheckList } from "./CheckList";
import { OfferCard } from "./OfferCard";
import { SectionHeading } from "./SectionHeading";
import { knowList, offerHighlights } from "../data/content";
export function PricingOffer({
  id
}: {
  id: string;
}) {
  return <section id={id} className="bg-peach px-4 py-16" aria-labelledby={`${id}-title`} data-id="element-199" data-mp="1vrr84n5nx39o">
      <div className="mx-auto max-w-6xl" data-id="element-200" data-mp="1qsxtusijx88g">
        <SectionHeading id={`${id}-title`} title="Everything you need to build with confidence" accent="All in one pack" intro="WOODWORKING READY™ gives you a complete collection of 150 practical woodworking projects designed to take you from idea to finished build without the usual guesswork." data-id="element-201" data-mp="2nltah449kbt7" />
        <div className="mx-auto mt-8 max-w-3xl" data-id="element-202" data-mp="29la5y6z0bnvs">
          <p className="text-center font-heading text-sm font-semibold" data-id="element-203" data-mp="135zha5xjykft">Each project is created to help you know:</p>
          <div className="mt-4" data-id="element-204" data-mp="y5brfnl289n6">
            <CheckList items={knowList} columns={2} data-id="element-205" data-mp="y5211yw3s0gy" />
          </div>
        </div>
        <div className="mt-12" data-id="element-206" data-mp="1dq04oekucdxr">
          <OfferCard title="The complete Woodworking Ready™ collection" highlights={offerHighlights} data-id="element-207" data-mp="1dmuip87ids69" />
        </div>
      </div>
    </section>;
}